export default defineNuxtRouteMiddleware((to, from) => {
	if (["/project-x/transcript/", "/watchlist/"].includes(from.path)) {
		window.location.href = "/";
	}

	// Ignore internal Nuxt asset routes, Chrome DevTools requests, and embed routes
	if (
		to.path.startsWith("/_nuxt/") ||
		to.path.startsWith("/.well-known/") ||
		to.path.startsWith("/embed/")
	) {
		return;
	}

	if (to.path === "/top-features/" || to.path === "/broker-integration/") {
		return navigateTo("/platform/");
	}
	if (to.path === "/building-a-watchlist/") {
		return navigateTo("/create-stock-watchlist/");
	}
	if (
		to.path === "/project-x/transcript/" &&
		from.path !== "/project-x/transcript/"
	) {
		window.location.href = "https://lp.stockstotrade.com/project-x/transcript/";
	}

	if (to.path === "/watchlist/" && from.path !== "/watchlist/") {
		window.location.href =
			"https://trading.stockstotrade.com/stt-watchlist/step/watchlist/";
	}

	if (from.path === "/contact/" && to.path === "/contact/") {
		window.location.href = "/";
		return;
	}

	if (to.path === "/contact/") {
		window.location.href =
			"https://support.stockstotrade.com/hc/en-us/requests/new";
	}
	const imageFormats = [".jpg", ".jpeg", ".png", ".gif", ".svg", ".webp"];
	const scriptFormats = [".php", ".js", ".css2", ".json", ".css"];

	const hasFormat = (path, formats) =>
		formats.some((format) => path.endsWith(format));

	// Handle stock quote URL redirects to ensure uppercase symbols
	if (to.path.startsWith("/quote/") && to.path !== "/quote/") {
		const pathParts = to.path.split("/");
		if (pathParts.length >= 3) {
			const stockSymbol = pathParts[2];
			const uppercaseSymbol = stockSymbol.toUpperCase();

			// If the symbol is not already uppercase, redirect to uppercase version
			if (stockSymbol !== uppercaseSymbol) {
				const newPath = `/quote/${uppercaseSymbol}/`;
				console.log(`Redirecting ${to.path} to ${newPath}`);
				// Preserve query parameters when redirecting
				return navigateTo(
					{
						path: newPath,
						query: to.query
					},
					{ redirectCode: 301 }
				);
			}
		}
	}

	if (
		!to.path.endsWith("/") &&
		!hasFormat(to.path, [...imageFormats, ...scriptFormats])
	) {
		// Preserve query parameters when adding trailing slash
		return navigateTo(
			{
				path: to.path + "/",
				query: to.query
			},
			{ redirectCode: 301 }
		);
	}
});
